import { Controller } from "@hotwired/stimulus"
import { isMobileScreen } from '../helpers/media_helpers'
import { post } from '../helpers/request_helpers'

export default class extends Controller {
  static targets = ['message', 'button']
  static values = { url: String }

  async submit() {
    this.buttonTarget.disabled = true

    try {
      await post(this.urlValue, { body: this.#feedbackParams })
    } catch {
      this.buttonTarget.disabled = false
    }
  }

  get #feedbackParams() {
    return {
      url: location.href,
      message: this.messageTarget.value,
      platform: isMobileScreen() ? 'mobile' : 'desktop'
    }
  }
}
